import { render, staticRenderFns } from "./questionnaireDataStatisticsEdit.vue?vue&type=template&id=ed17990c"
import script from "./questionnaireDataStatisticsEdit.vue?vue&type=script&lang=js"
export * from "./questionnaireDataStatisticsEdit.vue?vue&type=script&lang=js"
import style0 from "./questionnaireDataStatisticsEdit.vue?vue&type=style&index=0&id=ed17990c&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports